import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class PageTitle extends Component {
    render() {
        return (
            <div className="row">
                <div className="col-sm-12">
                    <div className="page-title-box">
                        <h4 className="page-title">{this.props.title}</h4>
                        {this.props.title !== 'Dashboard' &&
                            <ol className="breadcrumb float-right">
                                <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                                <li className="breadcrumb-item active">{this.props.title}</li>
                            </ol>
                        }
                        <div className="clearfix"></div>
                    </div>
                </div>
            </div>
        )
    }
}

PageTitle.defaultProps = {
    title: 'Default title',
}

export default PageTitle;


// WEBPACK FOOTER //
// ./src/components/PageTitle.js